import React from 'react';

interface Props {
  tplWmm:  number;
  tplHmm:  number;
  matWmm:  number;
  matHmm:  number;
  onCrop:   () => void;
  onCancel: () => void;
}

const TemplateMismatchDialog: React.FC<Props> = ({ tplWmm, tplHmm, matWmm, matHmm, onCrop, onCancel }) => (
  <div className="layers-overlay">
    <div className="param-dialog" style={{ maxWidth: 380 }}>
      <div className="param-title" style={{ color: '#ffaa44' }}>Template bigger than material</div>
      <p style={{ margin: '12px 0', fontSize: 13, lineHeight: 1.5 }}>
        Template: <b>{tplWmm.toFixed(1)} × {tplHmm.toFixed(1)} mm</b><br />
        Material: <b>{matWmm.toFixed(1)} × {matHmm.toFixed(1)} mm</b><br /><br />
        The template exceeds the material size. Choose an action:
      </p>
      <button style={{ width: '100%', marginBottom: 8 }} onClick={onCrop}>
        Crop to material size (centered, 1 mm border)
      </button>
      <button style={{ width: '100%' }} onClick={onCancel}>
        Cancel (do not use this template)
      </button>
    </div>
  </div>
);

export default TemplateMismatchDialog;
